<section>
    <div class="container">
        <div class="row fade-bottom" data-anima="" data-time="1000"
            style="position: relative; animation-duration: 1000ms; transition-timing-function: ease; transition-delay: 0ms;"
            aid="0.182260865684712">
            <div class="col-lg-6">
                <div class="title">
                    <h2 class="text-primary">Request a free<br>consultation with us</h2>
                    <p class="text-secondary">Contact us now</p>
                </div>
                <p style="color: rgb(64, 77, 96);">
                    With the aid of our skilled US-based team of software development professionals, we form long-term
                    relationships with our clients in order to assist them in expanding their businesses.
                </p>
                <a routerLink="/policy" href="/policy" class="btn-text active" aria-label="Our privacy policy">You
                    accept our policy</a>
            </div>
            <div class="col-lg-6">
                <form method="post" [formGroup]="contact" (submit)="onSubmit()">
                    <div class="row">
                        <div class="col-lg-6">
                            <input id="name" formControlName="name" name="name" placeholder="Name" type="text"
                                class="input-text" required="required" />
                            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert alert-danger">
                                <div *ngIf="name.errors?.['required']">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <input id="email" formControlName="email" name="email" placeholder="Email" type="email"
                                class="input-text" required="required" email />
                            <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                                <div *ngIf="email.errors?.['required']">
                                    Email is required.
                                </div>
                                <div *ngIf="email.errors?.['email']">
                                    Email is invalid
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px;">
                        <textarea id="message" formControlName="message" name="message" placeholder="Message"
                            class="input-textarea" required="required"></textarea>
                        <div *ngIf="message.invalid && (message.dirty || message.touched)" class="alert alert-danger">
                            <div *ngIf="message.errors?.['required']">
                                Message is required.
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isBrowser && captchaReady">
                        <re-captcha #recaptcha formControlName="captcha" siteKey="6LcSrD4jAAAAAJLglEv2QQoAxIV2cOIhOm9h-1Ky">
                        </re-captcha>
                        <div style="margin-bottom: 20px;">
                            <div *ngIf="contact.get('captcha')?.invalid && (contact.get('captcha')?.dirty || contact.get('captcha')?.touched)" class="alert alert-danger">
                                <div *ngIf="contact.get('captcha')?.errors?.['required']">
                                    Captcha is required.
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    
                    <!-- Success Message -->
                    <div *ngIf="successMessage" class="alert alert-success" style="margin-bottom: 20px;">
                        {{ successMessage }}
                    </div>
                    
                    <!-- Error Message -->
                    <div *ngIf="errorMessage" class="alert alert-danger" style="margin-bottom: 20px;">
                        {{ errorMessage }}
                    </div>
                    
                    <button class="btn btn-secondary" type="submit" [disabled]="!contact.valid">
                        <span *ngIf="!isLoading; else loading">Send message</span>
                        <ng-template #loading>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Loading...</span>
                        </ng-template>
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>